import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "since-1991_svg__Ebene_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 72 77"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".since-1991_svg__st0{fill:none;stroke:#000;stroke-miterlimit:10}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "m16.6 67.55 3.77-21.34c.03-.19.04-.38 0-.56l-3.39-21.99M16.6 67.55l-.96 5.49c-.19 1.04.61 2.01 1.68 2.01h38.74c1.07 0 1.87-.96 1.68-2.01l-4.72-26.8c-.04-.2-.04-.42 0-.61l4.23-22.83",
        class: "since-1991_svg__st0"
      }),
      _createElementVNode("path", {
        d: "M24.88 1.94q-.405-.015-.81.18L12.68 7.81c-.53.27-.88.77-.94 1.37l-5.71 56.5c-.11 1 .69 1.88 1.69 1.88h8.85",
        class: "since-1991_svg__st0"
      }),
      _createElementVNode("path", {
        d: "M24.88 1.94c.58.01 1.17.35 1.46.89l11.21 20.81L47.92 2.9c.43-.84 1.46-1.19 2.3-.76L61.56 7.8c.53.27.88.77.94 1.37l5.72 56.49c.11 1-.69 1.88-1.69 1.88h-9.71",
        style: {"fill":"none","stroke":"#000","stroke-miterlimit":"47"}
      }),
      _createElementVNode("path", {
        d: "M24.88 1.94c.42 0 11.67.03 24.58.03M24.88 1.94q-.015 0 0 0",
        class: "since-1991_svg__st0"
      })
    ], -1))
  ]))
}
export default { render: render }